import { FC, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import { ReactComponent as BackgroundAccountButton } from "../../../assets/img/backgroundAccountButton.svg";
import { LogoutIcon } from "../../../assets/img/icons";

import { AuthContext } from "../../../contexts/AuthContext";
import { useUnsavedChangesOptional } from "../../../contexts/UnsavedChangesContext";

import Dropdown from "../../OldDropdown";
import Button from "../../Button";
import Divider from "../../Divider";

import styles from "./styles.module.scss";
import { logout } from "../../../services/authService";

const AccountButton: FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { user, getNameInitials } = useContext(AuthContext)!;
    const navigate = useNavigate();
    const unsavedChanges = useUnsavedChangesOptional();

    const goTo = (path: string) => {
        setIsOpen(false);
        if (unsavedChanges) {
            unsavedChanges.requestNavigate(path);
            return;
        }
        navigate(path);
    };

    const handleLogout = () => {
        setIsOpen(false);
        if (unsavedChanges) {
            unsavedChanges.requestLogout();
            return;
        }
        void logout();
    };

    return (
        <div className={styles.container}>
            <Dropdown
                open={isOpen}
                setOpen={setIsOpen}
                direction="bottom-right"
                trigger={
                    <div className={styles.button_container}>
                        <BackgroundAccountButton />
                        <span className={styles.initials}>
                            {getNameInitials()}
                        </span>
                    </div>
                }
            >
                <div className={styles.content_container}>
                    <div className={styles.user_info}>
                        {`Bienvenue `}
                        <b>
                            {user?.firstname && user?.lastname
                                ? `${user?.firstname} ${user?.lastname[0]}.`
                                : user?.pseudo}
                        </b>
                    </div>
                    <Divider className={styles.divider} />
                    <div className={styles.buttons_container}>
                        <Button
                            className={styles.option_button}
                            labelOptions={{ align: "left", noWrap: true }}
                            label="Mon compte"
                            variant="transparent"
                            size="small"
                            onClick={() => goTo("/account")}
                        />
                        <Button
                            className={styles.option_button}
                            Icon={LogoutIcon}
                            labelOptions={{ align: "left", noWrap: true }}
                            label="Se déconnecter"
                            variant="transparent"
                            size="small"
                            onClick={handleLogout}
                        />
                    </div>
                </div>
            </Dropdown>
        </div>
    );
};

export default AccountButton;
